/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Errors_Nogeneralpartner2Inputs */

const en_errors_nogeneralpartner2 = /** @type {(inputs: Errors_Nogeneralpartner2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No general partner found`)
};

/**
* | output |
* | --- |
* | "No general partner found" |
*
* @param {Errors_Nogeneralpartner2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const errors_nogeneralpartner2 = /** @type {((inputs?: Errors_Nogeneralpartner2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Errors_Nogeneralpartner2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_errors_nogeneralpartner2(inputs)
});
export { errors_nogeneralpartner2 as "errors_noGeneralPartner" }